import React from 'react'

function Footer() {
    return (
        <div>
            <footer class="footer">
                <h3>Made by Aniket Lawaniya</h3>
        
            </footer>
        </div>
    )
}

export default Footer
